module.exports = __webpack_public_path__ + "img/clock.43ff0446.svg";